/**
 * PDP: School Centre as line item property (cart + order admin).
 */
(function () {
  function init(root) {
    if (!root || root.dataset.elinProductSchoolZoneInit === '1') return;
    root.dataset.elinProductSchoolZoneInit = '1';

    const formId = root.dataset.productFormId;
    const form = formId ? document.getElementById(formId) : null;
    const selectCentre = root.querySelector('[data-elin-centre-name]');
    const errorEl = root.querySelector('[data-elin-product-school-zone-error]');
    const productForm = form && form.closest('product-form');

    if (!selectCentre || !form) return;

    selectCentre.addEventListener('change', function () {
      if (errorEl) {
        errorEl.textContent = '';
        errorEl.hidden = true;
      }
    });

    form.addEventListener(
      'submit',
      function (e) {
        const sub = e.submitter;
        if (!sub || sub.getAttribute('name') !== 'add') return;

        if (selectCentre.value) return;

        e.preventDefault();
        e.stopImmediatePropagation();

        const msg =
          (window.elinProductSchoolZoneStrings && window.elinProductSchoolZoneStrings.required) ||
          'Please select School Centre before adding to cart.';

        if (errorEl) {
          errorEl.textContent = msg;
          errorEl.hidden = false;
        }

        if (productForm && typeof productForm.handleErrorMessage === 'function') {
          productForm.handleErrorMessage(msg);
        }

        selectCentre.focus();
      },
      true
    );
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-elin-product-school-zone-root]').forEach(init);
  });
})();
